import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=382f63f2&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=382f63f2&prod&scoped=true&lang=scss"
import style1 from "./Shipment.vue?vue&type=style&index=1&id=382f63f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f63f2",
  null
  
)

export default component.exports